import React from 'react';

import { shallowEqual, useSelector } from 'react-redux';
import { Navigate, useLocation } from 'react-router';

import { selectUser } from '@/redux/user/selectors';

import ErrorBoundary from '../ErrorBoundary';

export interface RouteElementProps {
  auth?: boolean;
  comp: React.ComponentType;
}

/**
 * RouteElement handles route protection by redirecting unauthenticated users to login.
 * AuthCheck (at app level) handles the actual auth loading/checking.
 *
 * Public routes (login, login-new, signup) don't use RouteElement, so they remain accessible.
 * Protected routes use <Re> which triggers redirect if no user after AuthCheck completes.
 */
const RouteElement = (props: RouteElementProps) => {
  const { comp: OriginalComponent, auth = true } = props;
  const location = useLocation();
  const user = useSelector(selectUser, shallowEqual);

  if (!user && auth) {
    return (
      <Navigate
        to={{ pathname: '/login' }}
        state={`${location.pathname}${location?.search}${location.hash}`}
      />
    );
  }

  return (
    <ErrorBoundary>
      <OriginalComponent />
    </ErrorBoundary>
  );
};

export default RouteElement;
